import React from "react";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
  AddBoxOutlined,
  AutoAwesomeOutlined,
  BeenhereOutlined,
  CalendarMonthOutlined,
  CelebrationOutlined,
  FacebookOutlined,
  FolderOutlined,
  ManageAccountsOutlined,
  MapOutlined,
  PaidOutlined,
  PersonSearchOutlined,
  SearchOutlined,
  SmartToyOutlined,
} from "@mui/icons-material";
import {
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SceneBox from "components/SceneBox";

export default function FinanceHub() {
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");

  
  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="FINANCE" subtitle="Henrri" />
        <Box>
        </Box>
      </FlexBetween>

      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 1 */}
        <SceneBox
          value="Create Invoice"
          onClick={() => {
                window.open('https://henrri.net/fr-FR/Pilotage/DevisFacture/DevisFactureView?societeFrontaleId=572317&typeDoc=Facture&societeId=2079&exerciceId=2079&documentId=245126#/');
              }}
          icon={
            <AddBoxOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Find Invoice"
          onClick={() => {
                window.open('https://henrri.net/fr-FR/Pilotage/Liste/ListeView?exerciceId=2079&societeId=2079&societeFrontaleId=572317&typeFenetre=ListeDocuments&nomVue=Liste&flagFenetreDeBase=True#/documents');
              }}
          icon={
            <SearchOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
              />
              <SceneBox
          value="Payments"
          onClick={() => {
                window.open('https://henrri.net/fr-FR/Pilotage/TableauSituation/TableauSituationView?flagFenetreDeBase=True&nomVue=Tableau%20de%20situation&exerciceId=2079&societeId=2079&societeFrontaleId=572317#/');
              }}
          icon={
            <PaidOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="Devis"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 2 */}
        <SceneBox
                  value="Devis Folder"
          onClick={() => {
                window.open('https://drive.google.com/drive/folders/1i8UU22lE5OwSi-XB-mwIQDyuufYFcMUr?usp=sharing');
              }}
          icon={
            <FolderOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="Costs"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 3 */}
        <SceneBox
          value="Event"
          onClick={() => {
                window.open('https://docs.google.com/spreadsheets/d/1n-pD4mN1sjTEL9bqJC_EwQn01OtIEQXDrgDB_GNvpMI/edit?usp=sharing');
              }}
          icon={
            <CelebrationOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Frais Km"
          onClick = {() => {
              window.open('https://docs.google.com/spreadsheets/d/1xUFuaRcbC3vkdk174k3hZOq8CEsZeDRbAfsSZwipZ54/edit#gid=0');
            }}
          icon={
            <MapOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
          </Box>
          <FlexBetween marginTop={5}>
        <Header title="" subtitle="Third Part Services"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 4 */}
        <SceneBox
          value="Make"
          onClick={() => {
                window.open('https://eu1.make.com/organization/465848/payments');
              }}
          icon={
            <AutoAwesomeOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="ChatGPT"
          onClick = {() => {
              window.open('https://pay.openai.com/p/session/live_YWNjdF8xSE9yU3dDNmgxbnhHb0kzLF9PdGUwQlN2WHdGdzRqY25DU3NnNFBzNGZ4NnRWUlBv0100w7K134mR');
            }}
          icon={
            <SmartToyOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Salesmate"
          onClick={() => {
                window.open('https://flairflow.salesmate.io/#/app/setup/subscription/invoices');
              }}
          icon={
            <ManageAccountsOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Calendly"
          onClick = {() => {
              window.open('https://calendly.com/app/admin/billing');
            }}
          icon={
            <CalendarMonthOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Brigad"
          onClick = {() => {
              window.open('https://work.brigad.co/business/missions/invoices');
            }}
          icon={
            <PersonSearchOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Facebook"
          onClick = {() => {
              window.open('https://business.facebook.com/billing_hub/payment_activity?asset_id=3500090770320234&business_id=1469271419868548&placement=ads_manager&date=1695686400_1698451200');
            }}
          icon={
            <FacebookOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="DBF"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 4 */}
        <SceneBox
          value="DBF Audit"
          onClick={() => {
                window.open('https://customer.mycompanyfiles.fr/?l=1');
              }}
          icon={
            <BeenhereOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        </Box>
    </Box>
  );
};